import { httpClient } from "./httpClient";
import { API_ROUTES } from "../constants/apiRoutes";

export type LayoutQueryParams = {
  route?: string;
  platform?: number | string;
  template?: string;
  item_id?: string | number | null;
  position?: string;
};

export type ExtraQueryParams = Record<
  string,
  string | number | boolean | null | undefined
>;

const buildQueryString = (
  params: LayoutQueryParams,
  extra?: ExtraQueryParams,
) => {
  const qs = new URLSearchParams();
  Object.entries({ ...params, ...extra }).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    qs.append(key, String(value));
  });
  const queryString = qs.toString();
  return queryString ? `?${queryString}` : "";
};

export const getLayoutResourceApi = async (
  resource = "content",
  params: LayoutQueryParams = {},
  extraParams?: ExtraQueryParams,
) => {
  const defaults: LayoutQueryParams = {
    platform: 1,
    route: "home",
  };

  const query = buildQueryString({ ...defaults, ...params }, extraParams);

  return httpClient(`${API_ROUTES.LAYOUT}/${resource}${query}`, {
    method: "GET",
  });
};
